import React from "react"
import "./button.css"

type Props = {
  children: React.ReactNode
  isDisabled?: boolean
  isSmall?: boolean
  onClick: () => void
}

const Button = ({
  children,
  isDisabled = false,
  isSmall = false,
  onClick,
}: Props) => {
  return (
    <button
      className={
        `bg-igem-light-blue bg-opacity-80 py-4 uppercase rounded-[3px] text-white ${
          isSmall ? "px-3" : "px-6"
        } ${isDisabled ? "bg-igem-disabled cursor-not-allowed" : ""}` + "button"
      }
      disabled={isDisabled}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {children}
    </button>
  )
}

export default Button
